import React from "react";
import PastorReport from "../pastors/pastor-report/PastorReport";
import IdleWrapper from "../components/auth/IdleWrapper";

export default function PastorReportPage() {
  return <IdleWrapper> <PastorReport /> </IdleWrapper>;
}
